import { AlarmClockIcon, Layers01Icon, TaskDone01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { createFileRoute } from '@tanstack/react-router';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

export const Route = createFileRoute('/_authenticated/parts-management/categories')({
  component: PartsCategories,
});

function PartsCategories() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight text-balance">Parts Categories</h1>
        <p className="text-muted-foreground">
          Organize part by class, criticality, and consumption.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {[
          {
            title: 'Categories',
            value: '17',
            hint: 'Mapped to asset hierarchy',
            icon: Layers01Icon,
          },
          {
            title: 'Critical Families',
            value: '5',
            hint: 'Require 2x safety stock',
            icon: AlarmClockIcon,
          },
          {
            title: 'Standardized Specs',
            value: '61 templates',
            hint: 'Shared across plants',
            icon: TaskDone01Icon,
          },
        ].map((metric) => (
          <Card key={metric.title}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">{metric.title}</CardTitle>
              <HugeiconsIcon icon={metric.icon} className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-xl font-semibold">{metric.value}</div>
              <p className="text-xs text-muted-foreground">{metric.hint}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Category Snapshot</CardTitle>
          <CardDescription>Key usage insights and replenishment cadence</CardDescription>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Category</TableHead>
                <TableHead>Items</TableHead>
                <TableHead>Monthly Usage</TableHead>
                <TableHead>Lead Time</TableHead>
                <TableHead>Policy</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {[
                {
                  name: 'Mechanical Drives',
                  items: 182,
                  usage: 'High',
                  lead: '14 days',
                  policy: 'Min/Max',
                },
                {
                  name: 'Electrical Components',
                  items: 244,
                  usage: 'Medium',
                  lead: '7 days',
                  policy: 'Kanban',
                },
                {
                  name: 'Hydraulics',
                  items: 96,
                  usage: 'Low',
                  lead: '21 days',
                  policy: 'Order Point',
                },
                {
                  name: 'Consumables',
                  items: 321,
                  usage: 'High',
                  lead: '3 days',
                  policy: 'Vendor Managed',
                },
              ].map((row) => (
                <TableRow key={row.name}>
                  <TableCell className="font-medium">{row.name}</TableCell>
                  <TableCell className="tabular-nums text-muted-foreground">{row.items}</TableCell>
                  <TableCell>
                    <Badge variant="secondary">{row.usage}</Badge>
                  </TableCell>
                  <TableCell className="text-muted-foreground">{row.lead}</TableCell>
                  <TableCell>{row.policy}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
